export const ADD_PARTNER_SUCCEED = "ADD_PARTNER_SUCCEED";
export const ADD_PARTNER_FAILED = "ADD_PARTNER_FAILED";
export const EDIT_PARTNER_SUCCEED = "EDIT_PARTNER_SUCCEED";
export const EDIT_PARTNER_FAILED = "EDIT_PARTNER_FAILED";

export const DELETE_PARTNER_SUCCEED = "DELETE_PARTNER_SUCCEED";
export const DELETE_PARTNER_FAILED = "DELETE_PARTNER_FAILED";
